/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import {
    object, func, shape,
    string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import SubscriptionDropDown from '../Partials/SubscriptionDropDown';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import findSkuById from '../../../../../gql/queries/findSkuById';
import ErrorDialog from '../Dialogs/ErrorDialog';
import GenericSkeleton from '../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';
import { isEmpty } from '../../../utils/object';

const styles = (theme) => ({
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        width: '48%',
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
    },
    primaryButtonStyle: {
        color: theme.palette.white,
        backgroundColor: theme.palette.primaryButton,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.primaryButton}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        width: '48%',
    },
    btnContainer: {
        position: 'absolute',
        marginBottom: '22px',
        padding: '0 20px',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const SubscriptionFrequencyForm = ({
    openModal, classes, closeModal, brand, subscription, updateSubscriptionList, enableEditButton,
}) => {
    const { productId } = subscription;
    const productSku = `${subscription.brand}-${productId}`;

    const query = findSkuById(brand.domain, productSku, 'subscriptionsList { interval, duration, type } ');
    const { error, data, loading } = useQuery(query);

    if (loading || !data) {
        return <GenericSkeleton height="120px" width="25%" />;
    }

    const errorMsg = 'We are sorry, there seems to be a technical issue, please try again';
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `Failed to fetch CSM subscriptionsList data: content type findSkuById - query - ${query}`,
        });
        return (
            <ErrorDialog
                classes={classes}
                closeModal={closeModal}
                openModal={openModal}
                errorMessage={errorMsg}
            />
        );
    }

    let subscriptionsList = {};
    if (data) {
        subscriptionsList = data?.findSkuById?.subscriptionsList;
    }

    if (!isEmpty(subscriptionsList) && Object.keys(subscriptionsList).length < 1) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `CSM SubscriptionsList data is empty, no frequency options found ${subscriptionsList}`,
        });
        return (
            <ErrorDialog
                classes={classes}
                closeModal={closeModal}
                openModal={openModal}
                errorMessage={errorMsg}
            />
        );
    }

    return (
        <div className={classes.modalContainer}>
            <SubscriptionDropDown
                isDesktop
                enableEditButton={enableEditButton}
                fieldLabel="Frequency"
                subscription={subscription}
                subscriptionsList={subscriptionsList}
                updateSubscriptionList={updateSubscriptionList}
            />
        </div>
    );
};

SubscriptionFrequencyForm.defaultProps = {
    brand: {},
    subscription: {},
    openModal: () => {},
    closeModal: () => {},
};
SubscriptionFrequencyForm.propTypes = {
    classes: object.isRequired,
    brand: shape({
        domain: string,
    }),
    subscription: shape({
        productId: string,
    }),
    closeModal: func,
    openModal: func,
    updateSubscriptionList: func.isRequired,
    enableEditButton: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    updateSubFrequency: (frequencyData) => dispatch(EventDispatcher.updateSubscriptionFrequency(frequencyData)),
});

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SubscriptionFrequencyForm));
